"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleStringToDateConvertion = exports.handleDateToStringConvertion = exports.getTimeStringFromHours = exports.getTimeFromHours = exports.DEFAULT_VALUE_SHORT_NULLABLE = exports.DEFAULT_VALUE_SHORT = exports.DEFAULT_VALUE_FULL_NULLABLE = exports.DEFAULT_VALUE_FULL = exports.DEFAULT_DIVIDER = void 0;
exports.isNumber = isNumber;
exports.validateTimeAndCursor = void 0;
const DEFAULT_DIVIDER = exports.DEFAULT_DIVIDER = ':';
const DEFAULT_VALUE_SHORT = exports.DEFAULT_VALUE_SHORT = `00${DEFAULT_DIVIDER}00`;
const DEFAULT_VALUE_SHORT_NULLABLE = exports.DEFAULT_VALUE_SHORT_NULLABLE = `--${DEFAULT_DIVIDER}--`;
const DEFAULT_VALUE_FULL = exports.DEFAULT_VALUE_FULL = `00${DEFAULT_DIVIDER}00${DEFAULT_DIVIDER}00`;
const DEFAULT_VALUE_FULL_NULLABLE = exports.DEFAULT_VALUE_FULL_NULLABLE = `--${DEFAULT_DIVIDER}--${DEFAULT_DIVIDER}--`;
const formatTimeItem = (value, isNullable = false) => {
  return `${value || ''}${isNullable ? '--' : '00'}`.substring(0, 2);
};

/**
 * Checks if input is a number
 */
function isNumber(value) {
  const number = Number(value);
  return !isNaN(number) && String(value) === String(number);
}

/**
 * Validates time to keep the format:
 * default 00:00 or 00:00:00 if showSeconds is true
 *
 * The function also keeps track of the cursor position
 */
const validateTimeAndCursor = (showSeconds = false, value = '', defaultValue = '', divider = DEFAULT_DIVIDER, cursorPosition = 0, isNullable = false) => {
  const [oldHH, oldMM, oldSS] = defaultValue.split(divider);
  let newCursorPosition = Number(cursorPosition);
  let [HH, MM, SS] = String(value).split(divider);
  HH = formatTimeItem(HH, isNullable);
  if (Number(HH[0]) > 2) {
    HH = oldHH;
    newCursorPosition -= 1;
  } else if (Number(HH[0]) === 2) {
    if (Number(oldHH[0]) === 2 && Number(HH[1]) > 3) {
      HH = `2${oldHH[1]}`;
      newCursorPosition -= 2;
    } else if (Number(HH[1]) > 3) {
      HH = '23';
    }
  }
  MM = formatTimeItem(MM, isNullable);
  if (Number(MM[0]) > 5) {
    MM = oldMM;
    newCursorPosition -= 1;
  }
  if (showSeconds) {
    SS = formatTimeItem(SS, isNullable);
    if (Number(SS[0]) > 5) {
      SS = oldSS;
      newCursorPosition -= 1;
    }
  }
  const validatedValue = showSeconds ? `${HH}${divider}${MM}${divider}${SS}` : `${HH}${divider}${MM}`;
  return [validatedValue, newCursorPosition];
};

/**
 * Converts a Date to String with the format:
 * default 00:00 or 00:00:00 if showSeconds is true
 */
exports.validateTimeAndCursor = validateTimeAndCursor;
const handleDateToStringConvertion = (date, showSeconds) => {
  const d = new Date(date);
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const seconds = d.getSeconds().toString().padStart(2, '0');
  return `${hours}${DEFAULT_DIVIDER}${minutes}${showSeconds ? `${DEFAULT_DIVIDER}${seconds}` : ''}`;
};

/**
 * Converts a String to Date with the format:
 * If value is formatted as 00:00:00 it will return the date with chosen seconds
 * If value is formatted as 00:00 it will return the date with seconds set to 00
 */
exports.handleDateToStringConvertion = handleDateToStringConvertion;
const handleStringToDateConvertion = (value, originalDate) => {
  const [hours, minutes, seconds] = value.split(DEFAULT_DIVIDER);
  const date = originalDate || new Date(0, 0, 0);
  date.setHours(Number(hours));
  date.setMinutes(Number(minutes));
  date.setSeconds(Number(seconds || 0));
  return date;
};
exports.handleStringToDateConvertion = handleStringToDateConvertion;
const getTimeFromHours = hours => {
  const days = Math.floor(hours / 24);
  const hour = Math.floor(hours - days * 24);
  return {
    days,
    hours: hour
  };
};
exports.getTimeFromHours = getTimeFromHours;
const getTimeStringFromHours = hours => {
  const time = getTimeFromHours(hours);
  if (time.days) {
    return `${time.days} dag${time.days > 1 ? 'er' : ''} og ${time.hours} time${time.hours !== 1 ? 'r' : ''}`;
  }
  return `${time.hours} time${time.hours !== 1 ? 'r' : ''}`;
};
exports.getTimeStringFromHours = getTimeStringFromHours;